import React from "react";
import { useNavigate } from "react-router-dom";

const StartFreeTrial = () => {
  const navigate = useNavigate();
  return (
    <section className="w-full py-16 bg-white dark:bg-[#0F172A]">
      <div className="container mx-auto px-4">
        
        {/* Box */}
        <div className="relative overflow-hidden rounded-2xl px-6 md:px-16 py-16
          bg-gradient-to-br from-green-300 via-emerald-300 to-teal-300
          shadow-xl shadow-green-900/20">

          {/* Subtle light texture */}
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(255,255,255,0.18),transparent_60%)]" />

          {/* Content */}
          <div className="relative text-center text-black">
            
            <h6 className="uppercase tracking-widest text-black/80 mb-3">
              Let’s Try!
            </h6>

            <h2 className="text-2xl md:text-4xl font-semibold mb-4 leading-tight">
              Start Your 14-Day Free Trial
            </h2>

            <p className="max-w-2xl mx-auto text-black/90 text-sm md:text-base mb-10">
              We can help you to make your environment better.
            </p>

            <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mb-12">
              <button className="px-8 py-3 bg-blue-600 hover:bg-blue-700 transition rounded-full font-medium shadow-lg shadow-black/20 text-white" onClick={()=>navigate('/contact')}>
                Contact us
              </button>

              {/* <button className="px-8 py-3 border border-white/40 hover:bg-white/10 transition rounded-full font-medium" onClick={()=>navigate('/contact')}>
                Talk to an Expert
              </button> */}
            </div>

            <div className="flex flex-wrap justify-center gap-6 text-sm text-black/80">
              <span>✔ Free 14-day trial</span>
              <span>✔ No credit card required</span>
              <span>✔ Support 24/7</span>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default StartFreeTrial;
